import { Kpi, ChartCard, Bars, Donut, LineTrend } from "./widgets";

export default function SupportAnalytics({ data }) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-testid="support-kpis">
        <Kpi label="Avg first reply" value={data.avg_first_response_hours || 0} unit="hrs" accent="#1FB6C1" testId="kpi-support-first-reply" />
        <Kpi label="Avg resolution" value={data.avg_resolution_hours || 0} unit="hrs" accent="#A78BFA" testId="kpi-support-resolution" />
        <Kpi label="Resolved" value={data.resolved_count || 0} accent="#10B981" testId="kpi-support-resolved" note="In window" />
        <Kpi label="Escalated" value={data.escalated_count || 0} accent="#F59E0B" testId="kpi-support-escalated" />
        <Kpi label="SLA breaches" value={data.sla_breaches || 0} accent="#F43F5E" testId="kpi-support-breaches" note="Urgent > 24h · High > 72h" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <ChartCard title="Tickets by status" desc="All tickets" testId="chart-support-status">
          <Donut data={data.tickets_by_status} nameKey="status" valueKey="count" />
        </ChartCard>
        <ChartCard title="Tickets by priority" desc="All tickets" testId="chart-support-priority">
          <Bars data={data.tickets_by_priority} xKey="priority" yKey="count" color="#F43F5E" />
        </ChartCard>
        <ChartCard title="Tickets by type" desc="All tickets" testId="chart-support-type">
          <Bars data={data.tickets_by_type} xKey="type" yKey="count" color="#A78BFA" />
        </ChartCard>
        <ChartCard title="New tickets" desc="Daily volume in window" testId="chart-support-trend">
          <LineTrend data={data.tickets_trend} xKey="date" yKey="count" color="#F43F5E" />
        </ChartCard>
      </div>
    </div>
  );
}
